import type { SortDescriptor } from 'react-aria-components';

import type { ResolvedColumn } from './useDataTableColumns';

function compare(a: unknown, b: unknown) {
  if (a === b) {
    return 0;
  }

  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() - b.getTime();
  }
  if (typeof a === 'boolean' && typeof b === 'boolean') {
    return Number(a) - Number(b);
  }

  return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
}

export function sortRows<T>(rows: T[], columns: Array<ResolvedColumn<T>>, sortDescriptor?: SortDescriptor) {
  if (!sortDescriptor) {
    return rows;
  }

  const column = columns.find(({ id }) => id === sortDescriptor.column);
  const getSortValue = column?.getSortValue;

  if (!getSortValue) {
    return rows;
  }

  const direction = sortDescriptor.direction === 'descending' ? -1 : 1;

  return [...rows].sort((a, b) => {
    const aValue = getSortValue(a);
    const bValue = getSortValue(b);

    if (aValue === null || aValue === undefined) {
      return bValue === null || bValue === undefined ? 0 : 1;
    }
    if (bValue === null || bValue === undefined) {
      return -1;
    }

    return compare(aValue, bValue) * direction;
  });
}
